import { render, staticRenderFns } from "./statistics_reply_count.vue?vue&type=template&id=308d544c&scoped=true"
import script from "./statistics_reply_count.vue?vue&type=script&lang=ts"
export * from "./statistics_reply_count.vue?vue&type=script&lang=ts"
import style0 from "./statistics_reply_count.vue?vue&type=style&index=0&id=308d544c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "308d544c",
  null
  
)

export default component.exports